// extracted by mini-css-extract-plugin
export default {"container":"nav_header-module__container--sKsN0"};